import { FC } from 'react';
interface Props {
  width?: string;
  height?: string;
}

const SecondEmpty: FC<Props> = ({ width = '38', height = '48' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 38 48" fill="none">
      <path
        d="M4.12182 33.9098C-1.98138 23.3387 -0.121171 10.3673 7.82364 1.91721C9.52604 0.106637 12.3737 0.018997 14.1843 1.72136C15.9949 3.42377 16.0825 6.27143 14.3802 8.08206C9.07968 13.7197 7.85284 22.3721 11.9161 29.4098C15.9567 36.4084 23.9966 39.6751 31.4942 37.9685C33.9173 37.4173 36.3285 38.9345 36.88 41.3576C37.4315 43.7808 35.9142 46.1919 33.4909 46.7434C22.2542 49.301 10.1913 44.4224 4.12182 33.9098Z"
        fill="#D9CCB9"
      />
      <path
        d="M11.483 29.6597C7.30671 22.4261 8.56835 13.534 14.0157 7.73989C15.5289 6.13051 15.4513 3.59902 13.8422 2.08576C12.2328 0.572625 9.70131 0.650213 8.18805 2.25932C0.390019 10.5533 -1.43493 23.2852 4.55482 33.6597C10.5114 43.9769 22.3507 48.7664 33.3799 46.2561C35.5339 45.7658 36.8828 43.6225 36.3927 41.4686C35.9025 39.3148 33.7591 37.9659 31.6052 38.4558C23.8996 40.2097 15.6363 36.8534 11.483 29.6597ZM12.349 29.1597C16.2771 35.9634 24.0935 39.1403 31.3831 37.4812C34.0754 36.8687 36.7544 38.5542 37.3673 41.2465C37.98 43.939 36.2944 46.6178 33.602 47.2307C22.1577 49.8355 9.87107 44.8677 3.6888 34.1597C-2.52775 23.3923 -0.632169 10.1812 7.4592 1.57504C9.35067 -0.436619 12.5146 -0.534311 14.5265 1.35691C16.5381 3.2484 16.6358 6.41237 14.7446 8.42417C9.59119 13.9054 8.39905 22.3181 12.349 29.1597Z"
        fill="#F7F3F0"
      />
    </svg>
  );
};

export default SecondEmpty;
